/**
 * Prefix een pad met /en als de taal Engels is,
 * en verwijdert /en als de taal Nederlands is.
 *
 * Werkt met:
 * - BrowserRouter (/en/academy)
 * - HashRouter (/#/en/academy)
 */
export function withLocale(path: string, language?: string) {
    const lang = (language ?? "nl-NL").toLowerCase();
    const isEn = lang.startsWith("en");

    // zorg dat path altijd met /
    let normalized = path.startsWith("/") ? path : `/${path}`;

    if (isEn) {
        // voorkom dubbele /en
        if (!normalized.startsWith("/en")) {
            normalized = `/en${normalized}`;
        }
    } else {
        // NL: strip /en als die er per ongeluk op zit
        normalized = normalized.replace(/^\/en(?=\/|$)/, "");
    }

    return normalized;
}
